import flux from 'flux'

export default new flux.Dispatcher()